import * as React from 'react';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import AvatarImg from './AvatarImg';
import SquareIcon from '@mui/icons-material/Square';
import SelectInTable from './SelectInTable';
import MenuSelect from './MenuSelect';
interface Data {
    id: number;
    bussinesName: string;
    email:string;
    ImagenUsuario:string ;
    abrvName:string;
    sede: string;    
    areaProject: string;      
  }
 
  
  function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  type Order = 'asc' | 'desc';
  
  function getComparator<Key extends keyof any>(
    order: Order,
    orderBy: Key,
  ): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string },
  ) => number {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  } 

  function stableSort<T>(array: readonly T[], comparator: (a: T, b: T) => number) {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  
  interface HeadCell {
    disablePadding: boolean;
    id:  keyof Data;
    label: string;    
  }
  
  const headCells: readonly HeadCell[] = [
    {
      id: 'bussinesName',      
      disablePadding: true,
      label: 'Nombre de colaborador',
    },
    {
      id: 'sede',    
      disablePadding: false,
      label: 'Sede',
    },
    {
      id: 'areaProject',       
      disablePadding: false,
      label: 'Área o proyecto',
    },   
  ];

  const headers=(info:any)=>{    
    let headerOption:any=[{
      id: 'Lider',    
      disablePadding: false,
      label:`Líder (${info.pctLider}%)` ,
    },  ]
    switch (info.tipoEvaluacion) {
      case "90":      
      const headCells90=[...headCells,...headerOption]      
      return  headCells90      
      case "180":
        headerOption=[...headerOption,{
          id: 'Colegas',    
          disablePadding: false,
          label:`Colegas (${info.pctColegas}%)` ,
        } ]
       const headCells180=[...headCells,...headerOption]   
      return  headCells180
      case "270":
        headerOption=[...headerOption,{
          id: 'Colegas',    
          disablePadding: false,
          label:`Colegas (${info.pctColegas}%)` ,
        }, 
        {id: 'Subordinados',    
        disablePadding: false,
        label:`Subordinados (${info.pctSubordinados}%)` ,
        }       
      ]
      const headCells270=[...headCells,...headerOption]   
      return  headCells270
      case "360":
        headerOption=[...headerOption,{
          id: 'Colegas',    
          disablePadding: false,
          label:`Colegas (${info.pctColegas}%)` ,
        }, 
        {id: 'Subordinados',    
        disablePadding: false,
        label:`Subordinados (${info.pctSubordinados}%)` ,
        },
        {id: 'Clientes',    
        disablePadding: false,
        label:`Clientes (${info.pctClientes}%)` ,
        },
      ]
      const headCells360=[...headCells,...headerOption]   
      return  headCells360
      
    }

    
  }
  
  interface EnhancedTableProps {
    numSelected: number;
    onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Data) => void;
    onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
    order: Order;
    orderBy: string;
    rowCount: number;
    info:{
      pctAutoevaluacion:number;
      pctClientes:number;
      pctColegas:number;
      pctLider:number;
      pctSubordinados:number;
      tipoEvaluacion:string;
    }
  }
  
  function EnhancedTableHead(props: EnhancedTableProps) {  
    const { onSelectAllClick, order, orderBy, numSelected,
        rowCount,info,
        onRequestSort } =
      props;
    const createSortHandler =
      (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
        onRequestSort(event, property);
      };  
     const header = headers(info)
    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox"  className="tableHeader">
            <Checkbox
             checkedIcon={
                    <SquareIcon sx={{  
                               background: 'radial-gradient(#979797 10px 100%,  #ffffff 100%)',
                               color: "#fabb00", 
                               stroke: "#ffffff",
                              strokeWidth: 2 
                                                  }}
                                                    />
                    }
              indeterminateIcon={
                <SquareIcon sx={{  
                  background: 'radial-gradient(#979797 10px 100%,  #ffffff 100%)',
                  color: "#fabb00", 
                  stroke: "#ffffff",
                  strokeWidth: 2 
                                    }}
                                     />
              }
              sx={{
                color: "#979797",   
            }}  
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{
                'aria-label': 'Seleccionar todas las incidencias',
              }}
            />    
          </TableCell>
           {header?.map((headCell) => (
            <TableCell
              className="tableHeader"
              key={headCell.id}                   
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
               <TableSortLabel
                active={orderBy === headCell.id}
                 direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
                className="labelHeader"
              >
                {headCell.label}             
              </TableSortLabel>
            </TableCell>
          ))           } 
        </TableRow>
      </TableHead>
    );
  }

const TableCollaboratorPerformanceEval = ({
  rows,setArrayIncident,selected,setSelected,page,setPage,info,
  arrayEval,setArrayEval}:any) => {
    const [order, setOrder] = React.useState<Order>("desc");
    const [orderBy, setOrderBy] = React.useState<keyof Data>("id");  
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const typesArray = ['lider-ext', 'colegas-ext', 'subornidados-ext', 'clientes-ext']
    const handleRequestSort = (
      event: React.MouseEvent<unknown>,
      property: keyof Data
    ) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };

    
     
    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
       let newSelected = rows.map((n:any) => {        
            return n.id            
         });                
        setSelected(newSelected);        
        setArrayIncident(newSelected)
        return;
      }      
      setSelected([]);
      setArrayIncident([]);
    };  

    const handleClick = (event: React.MouseEvent<unknown>, id: number) => {
      const selectedIndex = selected.indexOf(id);
      let newSelected: readonly number[] = [];
  
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, id);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1)
        );
      }
      setSelected(newSelected);
      setArrayIncident(newSelected)
    };
  
    const handleChangePage = (event: unknown, newPage: number) => {      
      setPage(newPage);
    };

  
    const handleChangeRowsPerPage = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
  
    const isSelected = (id: number) => selected.indexOf(id) !== -1;
  
    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;    
    
    const visibleRows = React.useMemo(
      () =>
        stableSort(rows, getComparator(order, orderBy)).slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        ),
      [order, orderBy, page, rows, rowsPerPage]
    );            
    
    //console.log(rows)
    return (
      <>
      <Box >
        <Paper >
          <TableContainer  >
            <Table >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
                info={info}
              />
              <TableBody>
                {visibleRows.map((row:any, index) => {
                  const castId=Number(row.id)
                  const isItemSelected = isSelected(castId);
                  const labelId = `enhanced-table-checkbox-${index}`;                 
                  return (
                    <TableRow             
                      hover                              
                      tabIndex={-1}
                      key={row.id}      
                      sx={{ cursor: "pointer" }}                
                    >
                      <TableCell padding="checkbox">                  
                        <Checkbox
                          onClick={(event) => handleClick(event, castId)}
                          checked={isItemSelected}                        
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                          checkedIcon={
                            <SquareIcon sx={{  
                              background: 'radial-gradient(#979797 10px 100%,  #ffffff 100%)',
                              color: "#fabb00", 
                              stroke: "#ffffff",
                             strokeWidth: 2 
                              }}
                            />
                          }
                           sx={{ color: "#979797", }}                                                   
                        />                
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}     
                        style={{width: 'auto'}}                                           
                      >
                       <div className='containerInfoColaboratorWithImage'>
                         <div className="avatar"><AvatarImg 
                                                   image={row.ImagenUsuario}
                                                   abrv={row.abrvName} />
                         </div>                                               
                         <div className="containerTwo">
                          <div className="containerInfoNamePerEv"> {row.bussinesName} </div>
                          <div className="containerInfoEmail"> {row.email}  </div>      
                        </div>                     
                       </div>  
                      </TableCell>
                      <TableCell align="left">{row.sede}</TableCell>
                      <TableCell align="left">{row.areaProject}</TableCell>                      
                      {/* {} */}
                      {info.tipoEvaluacion ==='90'?
                        <>
                        <TableCell align="left">
                        <div className="contSelectMen ">
                         <div>
                          <SelectInTable                                                                               
                            infoCol={row}
                            Array ={row.lider}                             
                            type={info.tipoEvaluacion}  
                            disabledSelect={row.emailSend !== 'true'? false:true }                          
                            arrayEval={arrayEval}
                            setArrayEval={setArrayEval}
                            typeArrayEval={'lider'}
                            />
                          </div>
                          <div>
                            {row.emailSend !== 'true' ?
                            <MenuSelect 
                              id ={row.id} 
                              arraySelect ={row.lider} 
                              typeEval={info.tipoEvaluacion}
                              typeArray={typesArray[0]}
                              arrayEval={arrayEval}
                              setArrayEval={setArrayEval}     
                              typeArrayEval={'lider'}
                              />:
                              <></>
                            }
                          </div> 
                         </div>
                       </TableCell>
                        </> 
                      :info.tipoEvaluacion ==='180'?                     
                        <>
                         <TableCell align="left">
                        <div className="contSelectMen ">
                         <div>
                          <SelectInTable                                                                                
                            infoCol={row}
                            Array ={row.lider} 
                            type={info.tipoEvaluacion}
                            disabledSelect={row.emailSend !== 'true'? false:true }                          
                            arrayEval={arrayEval}
                            setArrayEval={setArrayEval}
                            typeArrayEval={'lider'}                                
                          />
                          </div>
                          <div>
                          {row.emailSend !== 'true' ?
                            <MenuSelect
                              id ={row.id}
                              arraySelect ={row.lider}  
                              typeEval={info.tipoEvaluacion}
                              typeArray={typesArray[0]}
                              arrayEval={arrayEval}
                              setArrayEval={setArrayEval}     
                              typeArrayEval={'lider'}
                            />:<></>}
                          </div> 
                         </div>
                         </TableCell>
                         <TableCell align="left">
                        <div className="contSelectMen ">
                         <div>
                          <SelectInTable                       
                            infoCol={row}
                            Array ={row.colega} 
                            type={info.tipoEvaluacion}
                            disabledSelect={row.emailSend !== 'true'? false:true }                          
                            arrayEval={arrayEval}
                            setArrayEval={setArrayEval} 
                            typeArrayEval={'colega'}   
                          />
                          </div>
                          <div>
                          {row.emailSend !== 'true' ?
                             <MenuSelect 
                              id ={row.id}
                              arraySelect ={row.colega}  
                              typeEval={info.tipoEvaluacion}
                              typeArray={typesArray[1]}
                              arrayEval={arrayEval}
                              setArrayEval={setArrayEval}     
                              typeArrayEval={'colega'}
                             />:<></>}
                           </div> 
                         </div>
                        </TableCell>
                        </> 
                      :info.tipoEvaluacion ==='270'?
                      <>
                      <TableCell align="left">
                     <div className="contSelectMen ">
                      <div>
                       <SelectInTable                                                    
                         infoCol={row}
                         Array ={row.lider} 
                         type={info.tipoEvaluacion}
                         disabledSelect={row.emailSend !== 'true'? false:true }                          
                         arrayEval={arrayEval}
                         setArrayEval={setArrayEval} 
                         typeArrayEval={'lider'}
                       />
                       </div>
                       <div>
                       {row.emailSend !== 'true' ?
                        <MenuSelect 
                         id ={row.id} 
                         arraySelect ={row.lider}  
                         typeEval={info.tipoEvaluacion}
                         typeArray={typesArray[0]}
                         arrayEval={arrayEval}
                         typeArrayEval={'lider'}
                        />:<></>}
                       </div> 
                      </div>
                      </TableCell>
                      <TableCell align="left">
                     <div className="contSelectMen ">
                      <div>
                       <SelectInTable        
                         infoCol={row}
                         Array ={row.colega}                          
                         type={info.tipoEvaluacion}
                         disabledSelect={row.emailSend !== 'true'? false:true }                          
                         arrayEval={arrayEval}
                         setArrayEval={setArrayEval} 
                         typeArrayEval={'colega'}
                       />
                       </div>
                       <div>
                       {row.emailSend !== 'true' ?
                         <MenuSelect 
                          id ={row.id} 
                          arraySelect ={row.colega}  
                          typeEval={info.tipoEvaluacion}
                          typeArray={typesArray[1]}
                          arrayEval={arrayEval}
                          typeArrayEval={'colega'}
                         />:<></>}
                       </div> 
                      </div>
                     </TableCell>
                     <TableCell align="left">
                     <div className="contSelectMen ">
                      <div>
                       <SelectInTable      
                         infoCol={row}                                             
                         Array ={row.subornidado}                          
                         type={info.tipoEvaluacion}
                         disabledSelect={row.emailSend !== 'true'? false:true }                          
                         arrayEval={arrayEval}
                         setArrayEval={setArrayEval} 
                         typeArrayEval={'subornidado'}
                       />
                       </div>
                       <div>
                       {row.emailSend !== 'true' ?
                         <MenuSelect 
                          id ={row.id} 
                          arraySelect ={row.subornidado}  
                          typeEval={info.tipoEvaluacion}
                          typeArray={typesArray[2]}
                          arrayEval={arrayEval}
                          typeArrayEval={'subornidado'}
                         />:<></>}
                         </div> 
                      </div>
                     </TableCell>
                      </> 
                      :info.tipoEvaluacion ==='360'?
                       <>
                      <TableCell align="left">
                     <div className="contSelectMen ">
                      <div>
                       <SelectInTable
                         infoCol={row}                                                    
                         Array ={row.lider}                          
                         type={info.tipoEvaluacion}
                         disabledSelect={row.emailSend !== 'true'? false:true }                          
                         arrayEval={arrayEval}
                         setArrayEval={setArrayEval} 
                         typeArrayEval={'lider'}
                       />
                       </div>
                       <div>
                       {row.emailSend !== 'true' ?
                        <MenuSelect 
                         id ={row.id} 
                         arraySelect ={row.lider}  
                         typeEval={info.tipoEvaluacion}
                         typeArray={typesArray[0]}
                         arrayEval={arrayEval}
                         typeArrayEval={'lider'}
                        />:<></>}
                        </div> 
                      </div>
                      </TableCell>
                      <TableCell align="left">
                     <div className="contSelectMen ">
                      <div>
                       <SelectInTable                                                    
                         infoCol={row}
                         Array ={row.colega}                          
                         type={info.tipoEvaluacion}
                         disabledSelect={row.emailSend !== 'true'? false:true }                          
                         arrayEval={arrayEval}
                         setArrayEval={setArrayEval} 
                         typeArrayEval={'colega'}                         
                       />
                       </div>
                       <div>
                       {row.emailSend !== 'true' ?
                        <MenuSelect 
                          id ={row.id} 
                          arraySelect ={row.colega}  
                          typeEval={info.tipoEvaluacion}
                          typeArray={typesArray[1]}
                          arrayEval={arrayEval}
                          typeArrayEval={'colega'}                         
                         />:<></>}
                       </div> 
                      </div>
                     </TableCell>
                     <TableCell align="left">
                     <div className="contSelectMen ">
                      <div>
                       <SelectInTable                                                    
                         infoCol={row}
                         Array ={row.subornidado}                          
                         type={info.tipoEvaluacion}
                         disabledSelect={row.emailSend !== 'true'? false:true }                          
                         arrayEval={arrayEval}
                         setArrayEval={setArrayEval} 
                         typeArrayEval={'subornidado'}
                       />
                       </div>
                       <div>
                       {row.emailSend !== 'true' ?
                        <MenuSelect 
                         id ={row.id} 
                         arraySelect ={row.subornidado}  
                         typeEval={info.tipoEvaluacion}
                         typeArray={typesArray[2]}
                         arrayEval={arrayEval}
                         typeArrayEval={'subornidado'}
                        />:<></>}
                        </div> 
                      </div>
                     </TableCell>
                     <TableCell align="left">
                     <div className="contSelectMen ">
                      <div>
                       <SelectInTable                                                    
                         infoCol={row}
                         Array ={row.cliente}                          
                         type={info.tipoEvaluacion}
                         disabledSelect={row.emailSend !== 'true'? false:true }                          
                         arrayEval={arrayEval}
                         setArrayEval={setArrayEval} 
                         typeArrayEval={'cliente'}
                       />
                       </div>
                       <div>
                       {row.emailSend !== 'true' ?
                        <MenuSelect 
                         id ={row.id} 
                         arraySelect ={row.cliente}  
                         typeEval={info.tipoEvaluacion}
                         typeArray={typesArray[3]}
                         arrayEval={arrayEval}
                         typeArrayEval={'cliente'}
                        />:<></>}
                       </div> 
                      </div>
                     </TableCell>
                      </>  
                      : <></>
                      }

                    </TableRow>
                  );
                })} 
                {emptyRows > 0 && (
                  <TableRow>
                    <TableCell colSpan={11} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5,10, 20]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage='Número de registros'    
          />
        </Paper>        
      </Box>
      
     
      
      </>
    );
}

export default TableCollaboratorPerformanceEval

